import { BaseFieldView } from '../BaseField/views';

export const FormulaFieldView = BaseFieldView.extend({
    initialize: function (options) {
        // check to see if the field should be hidden from the users view
        if (this.model.get('hidden')) {
            this.$el.hide();
            this.$el.addClass('hidden_formula');
        }

        FormulaFieldView.__super__.initialize.call(this, options);
        var _this = this;

        /* This will setup triggers for the fields so they issue a recalculate  */
        _.each(_this.model.get('options'), function (event) {
            var field = _this.form_collection.get(event.id);
            if (!field) {
                return false;
            } // erorr check, continue on

            field.on('change', function () {
                $f.utils.formula.calculate(_this.model, _this.form_collection);
            });
            return true;
        });
    },

    events: {
        'change input': 'save_value'
    }
});
